import React, { useState } from "react";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Projects", href: "/projects" },
  { label: "Resume", href: "/resume" },
  { label: "Contact", href: "/contact" },
];

const Navbar = ({ isDarkMode, onToggleTheme }) => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const toggleMobileMenu = () => setIsMobileOpen(!isMobileOpen);

  const renderLinks = (className) =>
    navLinks.map(({ label, href }) => (
      <a
        key={label}
        href={href}
        className={`${className} text-2xl font-bold hover:text-amber-500 dark:hover:text-amber-300 transition duration-300`}
      >
        {label}
      </a>
    ));

  return (
    <nav className="bg-white text-gray-900 dark:bg-gray-900 dark:text-white shadow-md sticky top-0 w-full z-10 transition-colors duration-300">
      <div className="max-w-screen-xl mx-auto px-4 py-2 flex justify-between items-center">
        {/* Logo */}
        <a href="/">
          <img
            src="/logo192.png"
            alt="Logo"
            className="w-12 h-12 rounded-full"
          />
        </a>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8">
          {renderLinks("")}
        </div>

        <div className="flex items-center gap-3 ml-4">
          <button
            onClick={onToggleTheme}
            className="p-2 rounded-full border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors duration-200"
            aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
            title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
          >
            {isDarkMode ? (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="5" strokeWidth="2" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 1v2m0 18v2m11-11h-2M3 12H1m18.778 7.778-1.414-1.414M6.636 6.636 5.222 5.222m14.556 0-1.414 1.414M6.636 17.364l-1.414 1.414" />
              </svg>
            ) : (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 12.79A9 9 0 1 1 11.21 3c0 0-1.21 5.79 2.4 9.4S21 12.79 21 12.79z"
                />
              </svg>
            )}
          </button>

          {/* Mobile Menu Button */}
          <button onClick={toggleMobileMenu} className="md:hidden focus:outline-none" aria-label="Toggle mobile menu">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMobileOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isMobileOpen && (
        <div className="md:hidden px-4 py-2 space-y-4 bg-gray-100 dark:bg-gray-800 transition-colors duration-300">
          {renderLinks("block")}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
